<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix">
      <h3 class="m-v-0 pull-left">我的计划</h3>
      <div class="pull-right">
        <router-link class="el-button el-button--success" :to="$location.plan_edit()">
          <icon name="plus"></icon>
          添加计划
        </router-link>
      </div>
    </div>
    <div v-for="group in groups" :key="group.term">
      <h4 class="text-primary m-t-10 m-b-5">{{group.term}}学年</h4>
      <el-table :data="group.list" border>
        <el-table-column prop="department_name" label="提交部门"></el-table-column>
        <el-table-column prop="type" label="计划类型">
          <template slot-scope="scope">{{plan_type_map[scope.row.type]}}</template>
        </el-table-column>
        <el-table-column prop="grade" label="年级"></el-table-column>
        <el-table-column prop="subject" label="学科"></el-table-column>
        <el-table-column prop="group" label="班级"></el-table-column>
        <el-table-column prop="time_create" label="提交时间">
          <template slot-scope="scope">{{scope.row.time_create | sub(0, -3)}}</template>
        </el-table-column>
        <el-table-column label="操作" class-name="no-padding" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="download(scope.row)"
                       :loading="scope.row.$$loading>0">下载
            </el-button>
            <router-link :to="$location.plan_edit({plan_uid: scope.row.uid})"
                         class="el-button el-button--mini el-button--warning">编辑
            </router-link>
            <el-button type="danger" size="mini" @click="deletePlan(group, scope.row)"
                       :loading="scope.row.$$loading>0">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'
import * as Plan from 'api/plan'
import plan_types from 'constants/plan_types'
import term from 'utils/term'

export default {
  data () {
    return {
      groups: null,
      ready: false,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [list] = await Promise.all([
          Plan.list(),
        ])
        let this_term = term()
        let map = {[this_term]: []}
        let groups = [{
          term: this_term,
          list: map[this_term],
        }]
        list.forEach(plan => {
          let list = map[plan.term]
          if (!list) {
            list = map[plan.term] = []
            groups.push({term: plan.term, list: list})
          }
          list.push(plan)
        })
        this.plan_types = plan_types
        this.plan_type_map = mapValues(keyBy(plan_types, 'id'), 'name')
        this.groups = groups
        this.ready = true
      })
    },
    download (plan) {
      this.$guard(plan, '$$loading')(async () => {
        this.$message('下载即将开始')
        location.href = await Plan.batch_download({uid: plan.uid})
      })
    },
    async deletePlan (group, plan) {
      if (plan.$$loading) return
      if (!await this.$dangerConfirm('确定要删除该教学计划吗？', '确认')) return
      this.$guard(plan, '$$loading')(async () => {
        await Plan.remove({uid: plan.uid})
        this.$message.success('删除成功')
        let idx = group.list.indexOf(plan)
        group.list.splice(idx, 1)
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/plan/PlanList.vue